module.exports = __webpack_public_path__ + "img/mobile-bn.d67717a1.png";